module.exports = __webpack_public_path__ + "static/media/icon_pbi-configure.b824e4bf.svg";